import { deliveryVisitData, facilityDetails } from '@constants/index';
import ServiceOutline from '@pages/Beneficiary-block/WomenComponent/ANC/CommonOutline/AddServiceOutline';
import CommonFormFields from '@pages/Forms/CommonFormFields';
import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './FacilityDetails.css';
import AlertPopup from '../../CreateNewChild/AlertPopup';
import { useSelector } from 'react-redux';
import { RootState } from '@store/reducers';
import { getData, getDataWithCache} from '../../../../../services/CommonApiService';
import endpoints from '@config/endpoints';
import { ancFormData } from '@constants/index';
import dayjs from 'dayjs';
import config from '@config/config';
import {  setAncPregBackHandler,  setANCVisitDate,  setFacilityDetails,  updateAncService } from '@store/actions/beneficiaryAction';
import { useDispatch } from 'react-redux';
import { errorLogger } from '@utils/applicationLogUtils';
import { ANC_COMMON_CONSTANTS, ANC_ROUTES, FacilityDetails as AncConstants } from '@constants/ancConstants';
import { addDaysToDate, getVisitDateThroughVHND, isMobilizerHavingValue, subtractDaysFromDate } from '@utils/commonUtils';
import FormatDate from '@utils/dateFormat';
import { DELIVERY_COMMON_CONSTANTS } from '../../DeliveryOutcome/constants/DeliveryConstants';
import { getLatestServiceAvailedDate } from '@services/ancApiServices';
import { getDeliveryOutcomeByPregnancyId } from '@services/pregnancyApiServices';
import { ancPeriodDateCalculation } from '../Forms/CreateAndEdit/AncDateCaluculation';
import { decodeWithKeyAndShift, encodeWithKeyAndShift } from '@utils/base64Utils';
import Spinner from '@components/common/Spinner';
import axios from '@utils/axiosExt';
import Auth from '@utils/auth';
import { toast } from 'react-toastify';


interface objectType {
  isError: boolean;
  message: string;
  isDisable: boolean;
  value: any;
  id?: any;
  code?: any;
  ufTaggedId?: any;
}

export interface formStateType {
  [key: string]: objectType;
}

const FacilityDetails = () => {
  const facilityObj: any = {
    facilityType: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined,
    },
    facilityName: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined,
    },
    hprName: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      ufTaggedId: '',
    },
    ashaName: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    ashaAbha: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },

    ashaAccompanyingName: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
  };
  const userId = localStorage.getItem('userId');
  const { state } = useLocation();

  const [serviceDetails, setServiceDetails] = useState(state);
  const navigate = useNavigate();
  const [vistFormData, setVisitFormData] = useState<any>(ancFormData)
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [navItemsModal, setnavItemsModal] = useState(['Facility Details']);
  const [selectPerc, setSelectedPerc] = useState<any>(0);
  const [facilityFormState, setFacilityFormState] =
    useState<formStateType>(facilityObj);
  const [facilityData, setFacilityData] = useState<any>(facilityDetails);
  const [formCompleted, setFormCompleted] = useState<boolean[]>(
    Array(navItemsModal.length).fill(false),
  );
  const [alertModalOpen, setAlertModalOpen] = useState<boolean>(false);
  const [modalTitle, setModalTitle] = useState<string>('');
  const [facilityDetailsRes, setFacilityDetailsRes] = useState<any>();
  const [visitTypeOptions, setVisitTypeOptions] = useState<any>();
  const [ufId, setUfId] = useState<string>('');
  const visitTypeOptionsRef:any = useRef(null);
  const [loader, setLoader] = useState<boolean>(false);
  const pregnancyId= useSelector((state: RootState) => state.beneficiary.currPregnancyId);
  const lmpDate= useSelector((state: RootState) => state.beneficiary.lmpDate);
  const diffInWeeks= useSelector((state: RootState) => state.beneficiary.diffInWeeks);
  const onSameDay = useSelector((state: RootState) => state.beneficiary.onSameDay);
  const facilityDetail = useSelector((state: RootState) => state.beneficiary.facilityDetails);
  const benfDetails = useSelector((state: RootState) => state.beneficiary.beneficiaryDetails);
  const currentFacilityDetails = useSelector((state: RootState) => state.beneficiary.currentFacilityDetails);
  const viewPregnancyDetails = useSelector((state: RootState) => state.beneficiary.viewPregnancyDetails);
  const eventExution = useSelector((state: RootState) => state.eventExution);
  const hasKeysOnFacility = currentFacilityDetails?Object.keys(currentFacilityDetails).length > 0:false;
  const userDetails = localStorage.getItem('userDetails');
  const decodedUserData=JSON.parse(decodeWithKeyAndShift(userDetails));
  const navs = 100 / navItemsModal.length;
  const [visitForm, setVisitForm] = useState<formStateType>({
    date: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    visitType: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: ''
    },
    completedWeeks: {
      isError: false,
      message: '',
      id: '',
      isDisable: false,
      value: '',

    },
  })
  const [deliveryVisitForm, setDeliveryVisitForm] = useState<formStateType>({
    date: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
  });
  const [deliveryVisistFormData, setDeliveryVisitData] = useState<any>(deliveryVisitData);
  const initialDate = new Date(lmpDate);
  initialDate.setDate(initialDate.getDate() + 31);
  
  const finalDate = new Date(initialDate);
  const currentDate = new Date();
  const timeDifference = currentDate.getTime() - finalDate.getTime();
  const dayDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));
  const isDeliveryVisit = serviceDetails?.isdeliveryDetails;
  const isDeliveryPreparedness = serviceDetails?.currRoute === '/beneficiaries/delivery-preparedness';

  useEffect(() => {
    if (isDeliveryPreparedness) {
      setFacilityData((prev: any) => ({
        ...prev,
        ashaAbha: {
          '#type': 'textfield',
          '#title': 'ABHA of ASHA accompanying PW',
          '#webform_key': 'ashaAbha',
          '#className': 'abhaNumber',
        },

        ashaAccompanyingName: {
          '#type': 'textfield',
          '#title': 'Name of ASHA accompanying PW',
          '#webform_key': 'ashaAccompanyingName',
          '#isDisabled': true,
        },
      }));
    }
  }, [isDeliveryPreparedness]);

  useEffect(() => {
    if (isDeliveryPreparedness) {
      if (facilityFormState.ashaAbha?.value?.length === 14) {
        fetchAshaByAbha(facilityFormState.ashaAbha.value);
      } else {
        setFacilityFormState((prevState: any) => ({
          ...prevState,
          ashaAccompanyingName: { ...prevState.ashaAccompanyingName, value: '', isError: false, message: '' },
        }));
      }
    }
  }, [facilityFormState.ashaAbha?.value]);

  const visitDateThrouhVHND = getVisitDateThroughVHND(eventExution);
  const [latestServiceDate, setLatestServiceDate] = useState<any>();
  const isSpecialTestService = (serviceDetails?.currRoute === ANC_ROUTES.SPECIAL_TEST || serviceDetails?.currRoute === ANC_ROUTES.USG)

  if (dayDifference >= 1) {
    currentDate.setDate(currentDate.getDate()-ANC_COMMON_CONSTANTS.VISIT_DATE_PERIOD);
  }
  
  const formattedFinalDate = currentDate.toISOString().split('T')[0];
  const dispatch = useDispatch();

  useEffect(() => {
    if (!pregnancyId) {
      return;
    }
    handleInitialData();
  }, [pregnancyId]);

  const handleInitialData = async () => {
    initialFetch();
    const latestServiceAvailedDate = await fetchLatestServiceAvailedDate(pregnancyId);
    const latestAvailedServiceDate = latestServiceAvailedDate?.data?.[0]?.get_latest_service_availed_date;
    setLatestServiceDate(latestAvailedServiceDate);
    if(isDeliveryVisit){
      handleDeliveryVisitDate(latestAvailedServiceDate)
    }
    else{
              setDeliveryVisitData((prevState:any) => ({
      ...prevState,
        date: {
          ...prevState.date,
          '#minDate': dayjs(latestAvailedServiceDate),
        },
    }))
    }
  }

  const fetchLatestServiceAvailedDate = async (pregnancyId: any) => {
    return await getLatestServiceAvailedDate(pregnancyId);
  }

    const checkVisitDateWithinOneMonth = (latestServiceDate: any) => {
    return latestServiceDate ? dayjs().diff(dayjs(latestServiceDate), 'day') < 90 ? dayjs(latestServiceDate) : subtractDaysFromDate(dayjs(), 90, 'day') : subtractDaysFromDate(dayjs(), 90, 'day');
  }

  const handleDeliveryVisitDate = async (latestAvailedServiceDate:any) => {
    const lastAncVisitDate = await getLastAncVisitDate();
    const minDate = lastAncVisitDate? dayjs().diff(dayjs(lastAncVisitDate), 'day') < 90 ? dayjs(lastAncVisitDate) : dayjs().subtract(config.serviceDateLimit, 'day'):    
    dayjs().subtract(config.serviceDateLimit, 'day');
    const minDateBasedOnLmp = addDaysToDate(lmpDate, 140, DELIVERY_COMMON_CONSTANTS.DAY);
     const minimimDate =  dayjs(minDate).isAfter(minDateBasedOnLmp) ? minDate : minDateBasedOnLmp
    setDeliveryVisitData((prevState:any) => ({
      ...prevState,
        date: {
          ...prevState.date,
          '#minDate': (latestAvailedServiceDate && !isSpecialTestService) ? checkVisitDateWithinOneMonth(latestAvailedServiceDate) : visitDateThrouhVHND ? visitDateThrouhVHND : minimimDate,
        },
    }))
  }

  const getBackDatedEntry = async (backdatedDetails:any) => {
    setLoader(true);
    if (onSameDay) {
      setFacilityFormState((prevState: any) => ({
        ...prevState,
        facilityName: {
          ...prevState.facilityName,
          value: backdatedDetails?.facilityName?.facility_name,
          label: backdatedDetails?.facilityName?.facility_name,
          id: backdatedDetails?.facilityName?.facility_id,
        },
        facilityType: {
          ...prevState.facilityType,
          value: backdatedDetails?.facilityTypeName?.facility_type_name,
          id: backdatedDetails?.facilityTypeName?.facility_type_id,
          code: backdatedDetails?.facilityTypeName?.facility_type_code,
        },
        hprName: {
          ...prevState.hprName,
          value: backdatedDetails?.healthProviderName?.value,
          id: backdatedDetails?.healthProviderName?.id,
          label: backdatedDetails?.healthProviderName?.label,
          code: backdatedDetails.healthProviderName?.code,
          ufTaggedId: backdatedDetails.healthProviderName?.ufTaggedId,
        },
        ashaName: {
          ...prevState.ashaName,
          value: backdatedDetails?.ashaName?.value,
          label: backdatedDetails?.ashaName?.label,
          id: backdatedDetails?.ashaName?.id,
          code: backdatedDetails?.ashaName?.code,
        },
      }));
      setVisitForm((prevState: any) => ({
        ...prevState,
        ['date']: {
          ...prevState['date'],
          value: visitDateThrouhVHND ? visitDateThrouhVHND : dayjs(new Date()).format('YYYY-MM-DD'),
        },
      }));
    }
    if(isDeliveryVisit) {
      const response = await getDeliveryOutcomeByPregnancyId(pregnancyId);
      setDeliveryVisitForm((prevState: any) => ({
        ...prevState,
        ['date']: {
          ...prevState['date'],
          value: response?.data[0]?.date_of_delivery ? dayjs(response?.data[0]?.date_of_delivery).format('DD-MM-YYYY') : '',
        },
      }));
    }
    setLoader(false);
  };

  
  useEffect(()=>{
    const fourthAncMetaData = ancPeriodDateCalculation(lmpDate, 4);
    const currentDate = dayjs();
    const fourthAncEndDate = dayjs(fourthAncMetaData.endDate);
    const daysSinceFourthAncEnd = currentDate.diff(fourthAncEndDate, 'day');
    
    let maxDate = FormatDate(currentDate);
    const rawMinDate = (!isSpecialTestService && latestServiceDate) ? checkVisitDateWithinOneMonth(latestServiceDate) : visitDateThrouhVHND ? visitDateThrouhVHND : formattedFinalDate;
    const ancFloorDate = dayjs(lmpDate);
    const minDate = dayjs(rawMinDate).isBefore(ancFloorDate) ? ancFloorDate : rawMinDate;
    
    let isFieldDisabled = false;
    let disabledMessage = '';
    
    if (daysSinceFourthAncEnd >= 0 && daysSinceFourthAncEnd <= 90) {
      maxDate = fourthAncMetaData.endDate;

      if (latestServiceDate && dayjs(latestServiceDate).isAfter(fourthAncEndDate)) {
        isFieldDisabled = true;
        disabledMessage = AncConstants.VISIT_DATE_IN_FUTURE_ERROR;
      }
    } else if (daysSinceFourthAncEnd > 90) {
      isFieldDisabled = true;
      disabledMessage = AncConstants.VISIT_DATE_BEYOND_30_DAYS_ERROR(false);
    }
  
    setVisitFormData((prevState: any) => ({
      ...prevState,
      ['date']: {
        ...prevState['date'],
        '#maxDate': maxDate,
        '#minDate': minDate,
        '#isDisabled': isFieldDisabled,
      }
    }));
    setVisitForm((prevState: any) => ({
      ...prevState,
      ['date']: {
        ...prevState['date'],
        'isError': isFieldDisabled,
        'message': disabledMessage,
      }
    }));
  },[dayDifference, latestServiceDate]);

  const storeUserId = localStorage.getItem('userId');
  const visitTypeOptionsData = localStorage.getItem('visitTypeOptions');

  const initialFetch = async () => {
    try {
      setLoader(true);
      if (hasKeysOnFacility) {
        setFacilityFormState((prevState: any) => ({
          ...prevState,
          facilityName: {
            ...prevState.facilityName,
            value: currentFacilityDetails?.facilityName,
            id: currentFacilityDetails?.facilityId,
          },
          facilityType: {
            ...prevState.facilityType,
            value: currentFacilityDetails?.facilityType,
          },
          hprName: {
            ...prevState.hprName,
            value: currentFacilityDetails?.hprName,
            id: currentFacilityDetails?.healthProviderId,
          },
          ashaName: {
            ...prevState.ashaName,
            value: currentFacilityDetails?.ashaName,
            id: currentFacilityDetails?.mobilizerId,
          },
          ashaAbha: {
            ...prevState.ashaAbha,
            value: currentFacilityDetails?.ashaAbha,
          },
          ashaAccompanyingName: {
            ...prevState.ashaAccompanyingName,
            value: currentFacilityDetails?.ashaAccompanyingName,
          },
        }));
        setVisitForm((prevState: any) => ({
          ...prevState,
          ['date']: {
            ...prevState['date'],
            value: visitDateThrouhVHND ? visitDateThrouhVHND : currentFacilityDetails.visitDate ? dayjs(currentFacilityDetails.visitDate).format('YYYY-MM-DD') : '',
          },
          ['visitType']: {
            ...prevState['visitType'],
            value: currentFacilityDetails?.visitType,
            code: currentFacilityDetails?.visitTypeCde,
          },
        }));
        setDeliveryVisitForm((prevState: any) => ({
          ...prevState,
          ['date']: {
            ...prevState['date'],
            value: visitDateThrouhVHND ? visitDateThrouhVHND : currentFacilityDetails.visitDate ? dayjs(currentFacilityDetails.visitDate).format('YYYY-MM-DD') : '',
          },
        }));
      }
       let visitTypeData:any;
      if(storeUserId && visitTypeOptionsData) {
        visitTypeData = JSON.parse(decodeWithKeyAndShift(visitTypeOptionsData));
      }
      else{
        visitTypeData = await getDataWithCache<any>(`${endpoints.getVisitType}`);
        localStorage.setItem('visitTypeOptions', encodeWithKeyAndShift(JSON.stringify(visitTypeData)));
      }
      const hprResponse = await getData<any>(`${endpoints.getHRPFlag}/${pregnancyId}`);
      const filteredPmsmaOption=visitTypeData?.data.filter((obj: any) => obj.type_name === 'PMSMA');
      const hrrStatusRes = await getData<any>(`${endpoints.getHRPStatus}/${pregnancyId}`);
      const pmsmaStatusRes = await getData<any>(`${endpoints.getPmsmaStatus}/${pregnancyId}`);
      if (pmsmaStatusRes && pmsmaStatusRes?.data && pmsmaStatusRes?.data.length > 0 && pmsmaStatusRes?.data[0]?.is_pmsma) {
        visitTypeData.data = visitTypeData?.data.filter((obj: any) => obj.type_name !== 'PMSMA');
      }
      if (hrrStatusRes && hrrStatusRes?.data && hrrStatusRes?.data.length > 0 && !hrrStatusRes?.data[0]?.get_hrp_status) {
        visitTypeData.data = visitTypeData?.data.filter((obj: any) => obj.type_name !== 'e-PMSMA');
      }
      
      if (hprResponse.data.length===0  && !isDeliveryVisit) {
        if(onSameDay && facilityDetail.visitTypeCode===filteredPmsmaOption[0].type_code){
          const filteredOption=visitTypeData?.data.filter((obj: any) => obj.type_name === 'Routine ANC');
          setVisitForm((prevState: any) => ({
            ...prevState,
            ['visitType']: {
              ...prevState['visitType'],
              value: filteredOption[0].type_name,
              code: filteredOption[0].type_code,
              id:filteredOption[0].type_id
            },
          }));
        }
      }
       if(onSameDay && !hasKeysOnFacility && !isDeliveryVisit && (!(facilityDetail.visitTypeCode===filteredPmsmaOption[0].type_code) ||hprResponse.data.length!==0 ) ){
        const filteredOption=visitTypeData?.data.filter((obj: any) => obj.type_code === facilityDetail.visitTypeCode);
        setVisitForm((prevState: any) => ({
          ...prevState,
          ['visitType']: {
            ...prevState['visitType'],
            value: filteredOption[0].type_name,
            code: filteredOption[0].type_code,
            id:filteredOption[0].type_id
          },
        }));
      }
      if(!onSameDay && !hasKeysOnFacility && !isDeliveryVisit){
        const filteredOption=visitTypeData?.data.filter((obj: any) => obj.type_name === 'Routine ANC');
        setVisitForm((prevState: any) => ({
          ...prevState,
          ['visitType']: {
            ...prevState['visitType'],
            value: filteredOption[0].type_name,
            code: filteredOption[0].type_code,
            id:filteredOption[0].type_id
          },
          ['date']: {
            ...prevState['date'],
            value: visitDateThrouhVHND ? visitDateThrouhVHND : '',
          },
        }));
      }
      const visitTypeOptions = visitTypeData?.data?.map((key: any) => ({
        value: key.type_name,
        label: key.type_name,
        id: key.type_id,
        code: key.type_code,
      }))
      setVisitForm((prevState: any) => ({
        ...prevState,
        ['completedWeeks']: {
          ...prevState['completedWeeks'],
          value: diffInWeeks
        }
      }));
      setVisitFormData((prevState: any) => ({
        ...prevState,
        visitType: {
          ...prevState.visitType,
          '#options': visitTypeOptions,
        }
      }))
      visitTypeOptionsRef.current = visitTypeOptions;
      setVisitTypeOptions(visitTypeOptions);
      const facilityDetailsRespone = await getDataWithCache<any>(`${endpoints.getLinkedFacilitiesByUserById}/${userId}`);
      setFacilityDetailsRes(facilityDetailsRespone?.data[0]);
      const parentFacility = facilityDetailsRespone.data[0]?.find((item: any) => item.is_parent === true);
      const facilityTypeOptions = facilityDetailsRespone?.data[0]?.map((key: any) => ({
        value: key.facility_type_name,
        label: key.facility_type_name,
        id: key.facility_type_id,
        code: key.facility_type_code,
      }));

      const facilityNameOptions = facilityDetailsRespone?.data[0]?.map((key: any) => ({
        value: key.facility_name,
        label: key.facility_name,
        id: key.facility_id,
        code: key.facility_code,
      }));
      !hasKeysOnFacility && setFacilityFormState((prevState: any) => ({
        ...prevState,
        facilityName: {
          ...prevState.facilityName,
          value: parentFacility?.facility_name,
          id: parentFacility?.facility_id
        },
        facilityType: {
          ...prevState.facilityType,
          value: parentFacility?.facility_type_name,
          id: parentFacility?.facility_type_id
        }
      }));
      setFacilityData((prevState: any) => {
        return {
          ...prevState,
          facilityType: {
            ...prevState.facilityType,
            '#options': facilityTypeOptions
          },
          facilityName: {
            ...prevState.facilityName,
            '#options': facilityNameOptions,
          }
        }
      });
      const facilityName = getFacilityDetailFromParentById(facilityDetail?.facilityId, facilityDetailsRespone?.data[0]);
      const facilityTypeName = getFacilityDetailFromParentById(facilityDetail?.facilityId, facilityDetailsRespone?.data[0]);
      fetchHprName(parentFacility?.facility_id, facilityName, facilityTypeName);
      setLoader(false);
    } catch(error:any){
      setLoader(false);
      errorLogger(error?.response?.data||error?.response||error)
    }
  }
  
  const getLastAncVisitDate = async () => {
    try {
      setLoader(true);
      const lmpDate = FormatDate(viewPregnancyDetails?.lmp);
      const serviceList: any = await getData(`${endpoints.getServiceListByPregnancyId}/${pregnancyId}/${lmpDate}`);
      const ancNo = getAncNumber(serviceList?.data);
      if(ancNo) {
        const serviceListData = await getDataWithCache(
          `${endpoints.getServiceSubCategoryListByPregnancyId(pregnancyId,ancNo)}`
        );
        setLoader(false);
        return await getRecentVisitDate(serviceListData?.data ? serviceListData?.data : []);
      }
      setLoader(false);
    } catch(error:any){
      setLoader(false);
      errorLogger(error?.response?.data||error?.response||error)
    }
  }

  const getAncNumber = (serviceData:any) => {
    if(serviceData.length) {
      const ancServices = serviceData?.filter((service: any) => service.service_period_name.startsWith('ANC'));
      if(ancServices.length) {
        const ancNumbers = ancServices.map((service: any) => parseInt(service.service_period_name.replace('ANC ', '')));
        return Math.max(...ancNumbers);
      }
    }
  }

  const getRecentVisitDate = (serviceListData: any) => {
    return serviceListData.map((service: any) => dayjs(service.anc_visit_date))
      .reduce((latest:any, current:any) => (current.isAfter(latest) ? current : latest), dayjs(0));
  };

  const getName = (...parts: Array<string | null | undefined>) =>
    parts.filter((part) => typeof part === 'string' && part.trim()).join(' ');

  const fetchHprName = async (id: any, facilityName?:any, facilityTypeName?:any) => {
    try {
      setLoader(true);
      if(id){
      const Health_provider = await getDataWithCache<any>(`${endpoints.getHealthProviderTagged(id)}`);
      const healthProviderOptions = Health_provider?.data?.map((key: any) => ({
        value: getName(key?.f_name, key?.l_name),
        label: getName(key?.f_name, key?.l_name),
        id: key?.user_id,
        code: key?.user_code,
        ufTaggedId: key?.uf_tagged_id
      })).filter((option: any) => option.value);
      const currUserName = getName(decodedUserData.first_name, decodedUserData.middle_name, decodedUserData.last_name);
      const healthProviderData = Health_provider?.data.find((item: any) => getName(item?.f_name, item?.l_name) === currUserName);
    
      !hasKeysOnFacility && setFacilityFormState((prevState: any) => ({
        ...prevState,
        hprName: {
          ...prevState.hprName,
          value: getName(healthProviderData?.f_name, healthProviderData?.l_name),
          id: healthProviderData?.user_id,
          label: getName(healthProviderData?.f_name, healthProviderData?.l_name),
          code: healthProviderData?.user_code,
          ufTaggedId: healthProviderData?.uf_tagged_id,
        },
      }));
      const ashaNameRes = healthProviderData?.uf_tagged_id
        ? await getDataWithCache<any>(`${endpoints.getMobiliserTagged(healthProviderData.uf_tagged_id)}`)
        : null;
      const ashanameOptions = ashaNameRes?.data?.map((key: any) => ({
        value: getName(key?.f_name, key?.l_name),
        label: getName(key?.f_name, key?.l_name),
        id: key.mobiliser_id,
        code: key?.user_code
      })).filter((option: any) => option.value) || [];
      setFacilityData((prevState: any) => {
        return {
          ...prevState,
          hprName: {
            ...prevState.hprName,
            '#options': healthProviderOptions
          },
          ashaName: {
            ...prevState.ashaName,
            '#options': ashanameOptions
          }
        }
      });
      const ashaName = getFacilityDetailById(facilityDetail?.mobilizerId, ashanameOptions);
      const healthProviderName = getFacilityDetailById(facilityDetail?.healthProviderId, healthProviderOptions);
      const facilityDetails = {
          facilityName:facilityName,
          facilityTypeName:facilityTypeName,
          ashaName:ashaName,
          healthProviderName:healthProviderName,
      }
      !hasKeysOnFacility && getBackDatedEntry(facilityDetails);
      setLoader(false);
    }
    }catch(error:any){
      setLoader(false);
      errorLogger(error?.response?.data||error?.response||error)
    }
  }

  const fetchHealthProviderData = async () => {
    try {
      setLoader(true);
        const healthProviderData = await getDataWithCache<any>(`${endpoints.getHealthProviderTagged(facilityFormState.facilityName.id)}`);
        setFacilityData((prevState: any) => {
            return {
                ...prevState,
                ['hprName']: {
                    ...prevState['hprName'],
                    '#options': healthProviderData?.data.map((key: any) => ({
                    value: getName(key?.f_name, key?.l_name),
                    label: getName(key?.f_name, key?.l_name),
                        id: key.user_id,
                        code: key?.user_code,
                        ufTaggedId: key?.uf_tagged_id
                  })).filter((option: any) => option.value),
                }
            }
        })
        setLoader(false);
    }
    catch(error:any){
      setLoader(false);
        errorLogger(error?.response?.data||error?.response||error)
      }
}
    useEffect(() => {
        if (facilityFormState.facilityName.value !== '' && facilityFormState.facilityName.value !== undefined) {
            fetchHealthProviderData();
        }
    }, [facilityFormState.facilityName.value])
    useEffect(() => {
        if (facilityFormState.hprName.value !== '' && facilityFormState.hprName.value !== undefined &&
            ufId !== '' && ufId !== undefined
        ) {
            fetchAshaData();
        }
    }, [ufId])

  const fetchAshaByAbha = async (abhaNumber: string) => {
    try {
      setLoader(true);
      const payload = { p_abha_id: abhaNumber };
      const res = await axios.post(`${endpoints.getAshaByAbha}`, payload, Auth.loggedInWithJSON());
      const user = res?.data?.data?.[0];
      if (user) {
        setFacilityFormState((prevState: any) => ({
          ...prevState,
          ashaAccompanyingName: { ...prevState.ashaAccompanyingName, value: user.asha_name || '', isError: false, message: '' },
        }));
      } else {
        setFacilityFormState((prevState: any) => ({
          ...prevState,
          ashaAccompanyingName: { ...prevState.ashaAccompanyingName, value: '', isError: false, message: '' },
        }));
        toast.error(
          'Entered ABHA Number is not found in the Database. kindly register the ASHA under the common master module',
          { position: 'top-center', autoClose: 5000 }
        );
      }
      setLoader(false);
    } catch (error: any) {
      setLoader(false);
      errorLogger(error?.response?.data || error?.response || error);
    }
  };

  const fetchAshaData = async () => {
    if (!ufId) {
      setFacilityFormState((prevState: any) => ({
        ...prevState,
        ['ashaName']: {
            ...prevState['ashaName'],
            value: '',
            id: ''
        }
      }))
      setFacilityData((prevState: any) => ({
        ...prevState,
        ['ashaName']: {
          ...prevState['ashaName'],
          '#options': []
        }
      }))
      return;
    }
    setLoader(true);
    const mobiliserTaggedData = await getDataWithCache<any>(`${endpoints.getMobiliserTagged(ufId)}`);
    setFacilityFormState((prevState: any) => ({
        ...prevState,
        ['ashaName']: {
            ...prevState['ashaName'],
            value: '',
            id: ''
        }
    }))
    setFacilityData((prevState: any) => {
        return {
            ...prevState,
            ['ashaName']: {
                ...prevState['ashaName'],
                '#options': mobiliserTaggedData?.data?.map((key: any) => ({
                value: getName(key?.f_name, key?.l_name),
                label: getName(key?.f_name, key?.l_name),
                    id: key.mobiliser_id
              })).filter((option: any) => option.value)
            }
        }
    })
    setLoader(false);
}

  const getFacilityDetailById = (id:any, dataList:any) => {
    return dataList?.find((item:any) => item.id === id);
  }
  const getFacilityDetailFromParentById = (id:any, dataList:any) => {
    return dataList?.find((item:any) => item.facility_id === id);
  }
  const handleFacilityFormChange = (value: any, key: string, id: any, option: any, code: any,) => {

    if (key === 'facilityName' && !value) {
      setFacilityFormState((prevState: any) => ({
        ...prevState,
        facilityType: {
          ...prevState.facilityType,
          value: '',
        },
        hprName: {
          ...prevState.hprName,
          value: '',
        }
      }));
    }
    if (key === 'facilityType' && !value) {
      setFacilityFormState((prevState: any) => ({
        ...prevState,
        facilityName: {
          ...prevState.facilityName,
          value: '',
        },
        hprName: {
          ...prevState.hprName,
          value: '',
        }
      }));
    }
    if (key === 'facilityName' && value) {
      const facilityDetail = facilityDetailsRes?.find((item: any) => item.facility_name === value);
      fetchHprName(facilityDetail.facility_id);
      setFacilityFormState((prevState: any) => ({
        ...prevState,
        facilityType: {
          ...prevState.facilityType,
          value: facilityDetail.facility_type_name,
          label: facilityDetail.facility_type_name,
          id: facilityDetail.facility_type_id,
          code: facilityDetail.facility_type_code,
        }
      }))
    }

    if (key === 'facilityType' && value) {
      const facilityDetail = facilityDetailsRes?.find((item: any) => item.facility_type_name === value);
      setFacilityFormState((prevState: any) => ({
        ...prevState,
        facilityName: {
          ...prevState.facilityName,
          value: facilityDetail.facility_name,
          label: facilityDetail.facility_name,
          id: facilityDetail.facility_id,
          code: facilityDetail.facility_code,
        }
      }))
    }
     if (value && key === 'hprName') {
      const ufTaggedId = option.find((item: any) => item.id === id);
      setUfId(ufTaggedId?.ufTaggedId || '')
  }
    setFacilityFormState((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
        id: id,
        code: code,
        isError: false,
        message: '',
      },
    }));
  };

  const handleANCFormChange = async (value: any | boolean, key: string, option?: any, id?: any, code?: any) => {
    setVisitForm((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
        isError: false,
        message: '',
        id: id,
        code: code
      },
    }))
  }
  const handleDeliveryVisitFormChange = async (value: any | boolean, key: string, option?: any, id?: any, code?: any) => {
    setDeliveryVisitForm((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
        isError: false,
        message: '',
        id: id,
        code: code
      },
    }))
  }
  const breadcrumbItemName = [
    { value: 'beneficiary', label: 'Facility Details' },
  ];

  const onHandleBackArrowButton = () => {
    const ancPregBackObj = {
      benfType:"female",
      menuItems:"Pregnancy Services",
    }
    dispatch(setAncPregBackHandler(ancPregBackObj));
    navigate(`/beneficiaries/view/${benfDetails[0]?.benef_id}`);
    dispatch(updateAncService('currentFacilityDetails', {}));
  };

  const handleNavClick = (index: number) => { };

  const finishHandler = async () => {
    let checkError = false;

    if (!facilityFormState.facilityType.value) {
      setFacilityFormState((prevState: any) => ({
        ...prevState,
        facilityType: {
          ...prevState.facilityType,
          isError: true,
          message: AncConstants.facilityTypeError,
        },
      }));
      checkError = true;
    }
    if (!facilityFormState.facilityName.value) {
      setFacilityFormState((prevState: any) => ({
        ...prevState,
        facilityName: {
          ...prevState.facilityName,
          isError: true,
          message: AncConstants.facilityNameError,
        },
      }));
      checkError = true;
    }
    if (!facilityFormState.hprName.value) {
      setFacilityFormState((prevState: any) => ({
        ...prevState,
        hprName: {
          ...prevState.hprName,
          isError: true,
          message: AncConstants.healthProviderName,
        },
      }));
      checkError = true;
    }
    if (isDeliveryPreparedness && facilityFormState.ashaAbha?.value && facilityFormState.ashaAbha.value.length !== 14) {
      setFacilityFormState((prevState: any) => ({
        ...prevState,
        ashaAbha: {
          ...prevState.ashaAbha,
          isError: true,
          message: 'ABHA of ASHA accompanying PW must be 14 digits',
        },
      }));
      checkError = true;
    }
    if (isDeliveryPreparedness && facilityFormState.ashaAbha?.value?.length === 14 && !facilityFormState.ashaAccompanyingName?.value) {
      setFacilityFormState((prevState: any) => ({
        ...prevState,
        ashaAccompanyingName: {
          ...prevState.ashaAccompanyingName,
          isError: true,
          message: 'Name of ASHA accompanying PW is required when ABHA is entered',
        },
      }));
      checkError = true;
    }
    if(!isDeliveryVisit) {
      if (!visitForm.visitType.value) {
        setVisitForm((prevState: any) => ({
          ...prevState,
          visitType: {
            ...prevState.visitType,
            isError: true,
            message: AncConstants.visitTypeError,
          },
        }));
        checkError = true;
      }      
      if (visitForm.date.isError && visitForm.date.message) {
        checkError = true;
      } else if (!visitForm.date.value) {
        setVisitForm((prevState: any) => ({
          ...prevState,
          date: {
            ...prevState.date,
            isError: true,
            message: AncConstants.ancVisitDateError,
          },
        }));
        checkError = true;
      }
    } 
    if(isDeliveryVisit) {
      if (!deliveryVisitForm.date.value) {
        setDeliveryVisitForm((prevState: any) => ({
          ...prevState,
          date: {
            ...prevState.date,
            isError: true,
            message: AncConstants.visitDateError,
          },
        }));
        checkError = true;
      }
    }


    if (!checkError) {
      const newFormCompleted = [...formCompleted];
      newFormCompleted[activeIndex] = true;
      setFormCompleted(newFormCompleted);
      const perc = (activeIndex + 1) * navs;
      setSelectedPerc(perc);
    } else {
      const newFormCompleted = [...formCompleted];
      newFormCompleted[activeIndex] = false;
      setFormCompleted(newFormCompleted);
      setSelectedPerc(0);
      return;
    }

    const selectedVisitTypeId = visitTypeOptions.find((item:any) => item.code === visitForm.visitType.code)?.id;
    navigate(serviceDetails?.currRoute);
    dispatch(setANCVisitDate(visitForm.date.value));
    dispatch(setFacilityDetails({
      facilityId: facilityFormState.facilityName.id,
      healthProviderId: facilityFormState.hprName.id,
      mobilizerId: isMobilizerHavingValue(facilityFormState.ashaName.id),
      visitDate:visitForm.date.value,
      visitTypeCode:selectedVisitTypeId,
    }));
    const currFacilityDetails = {
      facilityId: facilityFormState.facilityName.id,
      healthProviderId: facilityFormState.hprName.id,
      mobilizerId: isMobilizerHavingValue(facilityFormState.ashaName.id),
      visitDate:visitForm.date.value,
      visitTypeCode:selectedVisitTypeId,
      facilityName: facilityFormState.facilityName.value,
      facilityType: facilityFormState.facilityType.value,
      hprName: facilityFormState.hprName.value,
      ashaName: isMobilizerHavingValue(facilityFormState.ashaName.value),
      visitType:visitForm.visitType.value,
      visitTypeCde:visitForm.visitType.code,
      currRoute: serviceDetails?.currRoute,
    } 
    const deliveryVisitFacilityDetails = {
      facilityId: facilityFormState.facilityName.id,
      healthProviderId: facilityFormState.hprName.id,
      mobilizerId: isMobilizerHavingValue(facilityFormState.ashaName.id),
      facilityName: facilityFormState.facilityName.value,
      facilityType: facilityFormState.facilityType.value,
      hprName: facilityFormState.hprName.value,
      ashaName: isMobilizerHavingValue(facilityFormState.ashaName.value),
      currRoute: serviceDetails?.currRoute,
      visitDate:deliveryVisitForm?.date?.value,
      ashaAbha: facilityFormState.ashaAbha?.value,
      ashaAccompanyingName:facilityFormState.ashaAccompanyingName?.value,
    }
    
    dispatch(updateAncService('currentFacilityDetails', isDeliveryVisit ? deliveryVisitFacilityDetails : currFacilityDetails));
  };

  const contents = [
    <div key="Service">
    {loader? <Spinner /> :
    <div key="Service">
      <form className="general_details">
        <CommonFormFields
          formData={facilityData}
          formState={facilityFormState}
          handleFormChange={handleFacilityFormChange}
        />
      </form>
      <form className="anc_service_visit_details">
        {isDeliveryVisit ? (
          <CommonFormFields
            formData={deliveryVisistFormData}
            formState={deliveryVisitForm}
            handleFormChange={handleDeliveryVisitFormChange}
          />
        ) : (
          <CommonFormFields
            formData={vistFormData}
            formState={visitForm}
            handleFormChange={handleANCFormChange}
          />
        )}
      </form>
    </div>
    }
    </div>,
  ];


  const isFormChanged = (ancServiceFormState: any) => {
    for (const key in facilityObj) {
      if (ancServiceFormState[key].value !== facilityObj[key].value) {
        return true;
      }
    }
    return false;
  };

  const handleCancel = () => {
    if (isFormChanged(facilityFormState)) {
      setModalTitle(
        'You have unsaved changes. Are you sure you want to leave without saving?',
      );
      setAlertModalOpen(true);
      return;
    }
    setModalTitle('Do you want to close the form?');
    setAlertModalOpen(true);
  };

  const closeAlertModal = (value: boolean) => {
    if (value) {
      setAlertModalOpen(false);
      onHandleBackArrowButton();
    } else {
      setAlertModalOpen(false);
    }
  };

  return (
    <>
      <ServiceOutline
        breadcrumbItemName={breadcrumbItemName}
        onHandleBackArrowButton={onHandleBackArrowButton}
        navItemsModal={navItemsModal}
        activeIndex={activeIndex}
        handleNavClick={handleNavClick}
        formCompleted={[false]}
        headerName={`Facility Details`}
        progressBarPerc={selectPerc}
        contents={contents}
        finishHandler={finishHandler}
        handleCancel={handleCancel}
        title="Add Details"
      />
        <AlertPopup
        showModal={alertModalOpen}
        closeModal={closeAlertModal}
        title={modalTitle}
      />
    </>
  );
};

export default FacilityDetails;
